export default "__VITE_ASSET__CPe_RM1T__"